
export default {
  name: 'ProductCard',

  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    small: {
      type: Boolean,
      default: false,
    },
    lazyImage: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    productName: function () {
      if (this.product?.shortDescription) {
        return [
          this.product?.shortDescription,
        ].filter((t) => !!t).join(', ');
      }

      return [
        this.productChar,
        this.product?.name,
      ].filter((t) => !!t).join(', ');
    },
    productNameLink: function () {
      let mainName = [
        this.productChar,
        this.product?.name,
      ].filter((t) => !!t).join(', ');
      if (this.product?.shortDescription) {
        mainName = this.product?.shortDescription;
      }
      return [
        this.product?.characteristicGroup?.name,
        mainName,
      ].filter((t) => !!t).join(' ');
    },
    productPrice: function () {
      return this.product?.price;
    },
    productPriceForCount: function () {
      return this.productPrice * 4;
    },
    productSku: function () {
      return this.$productSku(this.product);
      return this.product?.code;
    },
    productOldPruce: function () {
      if (!this.product?.oldPrice || this.product?.oldPrice <= this.product.price) {
        return;
      }
      return this.product?.oldPrice;
    },
    productChar: function () {
      const shortCharacteristics = this.product?.shortCharacteristics || [];
      if (shortCharacteristics.length <= 0) {
        return;
      }

      const name = [];

      const disksize = shortCharacteristics.find((t) => t.slug === 'disksize');
      if (disksize) {
        name.push(disksize?.values?.[0]?.value || '');
      }

      const pcdBoltcount = shortCharacteristics.find((t) => t.slug === 'pcd-boltcount');
      if (pcdBoltcount) {
        name.push(pcdBoltcount?.values?.[0]?.value || '');
      }

      return name.filter((t) => !!t).join(', ');
    },
    productQuantityUnit: function () {
      return (this.product?.unit || '').replace('/', '');
    },
    productPresence: function () {
      const nalicieTovara = (this.product?.shortCharacteristics || []).find((t) => t.slug === 'nalicie-tovara')?.values?.[0];
      if (nalicieTovara) {
        return nalicieTovara?.value;
      }
      return 'Уточнить';
    },

    metaImage: function () {
      return this.$img(String(this.product.imageId));
    },
    metaDescription: function () {
      let template = this.$store.state.appState?.vars?.['Шаблон META описания для карточки товара в каталоге'] || '';
      if (!template) {
        return '';
      }

      template = template.replace(/\[name\]/g, this.productName);
      template = template.replace(/\[price\]/g, this.productPrice);

      return template;
    },

    countFromCart: function () {
      const items = this.$store.state?.cart?.items || [];
      const product = items.find((t) => t?.product?.id === this.product.id);
      return product?.quantity || 0;
    },
    cartProductId: function () {
      const items = this.$store.state?.cart?.items || [];
      const product = items.find((t) => t?.product?.id === this.product.id);
      return product?.id || '';
    },

    isProductPriceGray: function () {
      if (!!this.productQuantityUnit && this.productQuantityUnit !== 'шт') {
        return false;
      }

      return (this.product?.quantity || 0) < 4;
    },
    isAvaibleCountProduct: function () {
      return Boolean((this.product?.quantity || 0) > 0 && !this.product.isNotAvailable);
    },
    isVisiblePriceForCount: function () {
      if (this.productOldPruce) {
        return;
      }

      const notAvaible = JSON.parse(this.$store.state.appState?.vars?.['Типы товаров у которых скрывать цену за 4шт'] || '[]');
      if (notAvaible.includes(this.product.characteristicGroupId)) {
        return false;
      }

      if ((this.product?.quantity || 0) < 4) {
        return false;
      }

      return true;
    },

    characteristicSeason: function () {
      const item = (this.product?.shortCharacteristics || []).find((t) => t.slug === 'season')?.values?.[0] || null;
      if (!item) {
        return null;
      }

      return {
        icon: item?.image_id,
        value: item?.value,
      };
    },
    characteristicDiametr: function () {
      const item = (this.product?.shortCharacteristics || []).find((t) => t.slug === 'diameter')?.values?.[0] || null;
      if (!item) {
        return null;
      }

      return {
        value: item?.value,
      };
    },
    characteristicWidth: function () {
      const item = (this.product?.shortCharacteristics || []).find((t) => t.slug === 'width')?.values?.[0] || null;
      if (!item) {
        return null;
      }

      return {
        value: item?.value,
      };
    },
    characteristicPcd: function () {
      const item = (this.product?.shortCharacteristics || []).find((t) => t.slug === 'pcd-boltcount')?.values?.[0] || null;
      if (!item) {
        return null;
      }

      return {
        value: item?.value,
      };
    },
    characteristicHeight: function () {
      const item = (this.product?.shortCharacteristics || []).find((t) => t.slug === 'height')?.values?.[0] || null;
      if (!item) {
        return null;
      }

      return {
        value: item?.value,
      };
    },
    characteristicDia: function () {
      const item = (this.product?.shortCharacteristics || []).find((t) => t.slug === 'dia')?.values?.[0] || null;
      if (!item) {
        return null;
      }

      return {
        value: item?.value,
      };
    },
  },

  methods: {
    // Добавление / удаления товара в корзину
    addToCart: async function () {
      if (!this.isAvaibleCountProduct) {
        return;
      }
      const productItemCart = {
        productId: this.product.id,
        quantity: 1,
      };
      const res = await this.$store.dispatch('cart-custom/putToCart', productItemCart);
      if (!res.isSuccess) {
        this.$toast.error(res.errorMessage);
        return;
      }

      this.$toast.success('Товар добавлен в корзину');
      this.$yandexMetrika.reachGoal('add_to_cart_listing');
      this.$yandexCommerce('add', [{
        ...this.product,
        quantity: 1,
      }]);

      await this.$store.dispatch('cart/getCart');
    },
    updateForCart: async function (newCount) {
      if (!this.isAvaibleCountProduct) {
        return;
      }
      if (this.countFromCart <= 0 && newCount > 0) {
        await this.addToCart();
        return;
      }
      const count = this.countFromCart + newCount;
      if (count <= 0) {
        await this.removeFromCart();
        return;
      }
      const response = await this.$store.dispatch('cart-custom/updateCartItem', {
        cartItemId: this.cartProductId,
        quantity: count,
      });
      if (newCount > 0) {
        this.$yandexMetrika.reachGoal('add_to_cart_listing');
      }
      if (!response?.isSuccess) {
        this.$toast.error(response?.errorMessage);
        return;
      }

      this.$yandexCommerce(newCount > 0 ? 'add' : 'remove', [{
        ...this.product,
        quantity: 1,
      }]);
      await this.$store.dispatch('cart/getCart');
    },
    removeFromCart: async function () {
      this.$yandexCommerce('remove', [{
        ...this.product,
        quantity: 1,
      }]);
      await this.$store.dispatch('cart/removeCartItem', this.cartProductId);
      await this.$store.dispatch('cart/getCart');
    },
    orderOneClick: function (product) {
      this.$store.commit('fast-buy/open', product);
    },
  },
};
